module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABkAAAAZCAYAAADE6YVjAAAACXBIWXMAAAsSAAALEgHS3X78AAABGUlEQVRIie1WbRXCMAw8eAiYhEmohEmYBCQUB5MwCUiYhKIAJAwHQ8HxY9kIZZR08JN7Ly/rR3Jpm2YFSRjFkRw4YpC2ydZKAJIdn9FZbbewYQ/AyfdVtJP+z/gQRUWyZxq9zFu1Xa1yNJD0ypmTtg6gzSWplXFDskgE06i5dQ7JlEVvo4vEqxWbSCq11znZdxG7l/NZyq5KdDBm3oQusp+RSuE+kyS8G7Dek6/wJ/mTzChFDyt9li89ifKQqldLUvBRMP1SWSlIhqgo5hBMslc+Qkzi1eBaAu1rKrBek+gIfomKJHZyNEfRNYBi5YFr9BgLZgCADUmLUYnl//kRhkJqJXEAzlHfDcZVWy/jBcABj5fKCdaXCoA7RFWbqkL+FH0AAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./static/images/head/alarm.png
// module id = twFs
// module chunks = 0